<template>
  <el-container>
    <el-header height="80px">
      <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" @select="handleSelect" id="elMenu" >
        <el-menu-item @click="back()">后退</el-menu-item>
        <el-menu-item index="/sutongIndex">首页</el-menu-item>
        <el-menu-item index="/sutong/gasClamp">全桥实时数据</el-menu-item>
        <el-submenu index="/sutong/airValve">
          <template slot="title">风阀遥控</template>
          <el-menu-item index="/sutong/airValve/airValveRemote">风阀遥控</el-menu-item>
          <el-menu-item index="/sutong/airValve/remoteHistory">遥控记录</el-menu-item>
          <el-menu-item index="/sutong/airValve/airValveSwitch">开关状态(维护用)</el-menu-item>
        </el-submenu>
        <el-submenu index="/sutong/nantongDehumidifer">
          <template slot="title">南通侧除湿机</template>
          <el-menu-item index="/sutong/nantong/dehumidifierSmall">NA18梁段1-2号除湿机</el-menu-item>
          <el-menu-item index="/sutong/nantong/dehumidifierBig">NJ16梁段3-4号除湿机</el-menu-item>
        </el-submenu>
        <el-submenu index="/sutong/changshu">
          <template slot="title">常熟侧除湿机</template>
          <el-menu-item index="/sutong/changshu/dehumidifierBig">SJ16梁段5-6号除湿机</el-menu-item>
          <el-menu-item index="/sutong/changshu/dehumidifierSmall">SA18梁段7-8号除湿机</el-menu-item>
        </el-submenu>
        <el-menu-item index="/sutong/ventilation">排风</el-menu-item>
        <el-menu-item index="/sutong/bridgeImg">全桥除湿总体布置图</el-menu-item>
        <el-submenu :index="'/sutong/dataHistory?bridgeId=ca6d55dc-e059-4d72-b494-e3140e31b2fe&scenarioId=TBD'">
          <template slot="title">数据历史</template>
          <el-menu-item index="/sutong/dataHistory?bridgeId=ca6d55dc-e059-4d72-b494-e3140e31b2fe&scenarioId=TBD"> 查询数据历史 </el-menu-item>
          <el-menu-item index="/sutong/dataHistory?bridgeId=ca6d55dc-e059-4d72-b494-e3140e31b2fe"> 自定义数据历史 </el-menu-item>
        </el-submenu>
      </el-menu>
      <HeaderTime bridgeName="ZHEJIANG" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
    </el-header>
    <el-main class="el-main su-tong">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
export default {
  name: "sutong",
  data() {
    return {
      bridgeId: "ca6d55dc-e059-4d72-b494-e3140e31b2fe",
      envInfo: {
        envId: "ad665e33-a5c0-44b3-b203-159801664e22",
        weather: "f15e6973-301f-4e73-a4e3-e184c698cc95",
        humidity: "9b729e34-e7dd-4731-bc8a-edafd4592877",
        temperature: "799e3f4b-50a1-4bce-a6ee-b04c9b73541a",
      },
      id2Path: {},
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

    document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>

 <style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;;
  display: none;
}
</style>
